<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Earning Orders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Earning Orders",
            items: [
               {
                  text: "Drivers",
                  href: "/drivers",
               },  
               {
                  text: "Earnings",
                  href: "/drivers/earnings",
               },  
               {
                  text: "Orders",
                  active: true,
               },                   
            ],

            orders: [],            
            
            pagination: {},
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      methods: {
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'drivers' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                  <div class="row">
                     <div class="col-md-4">
                        <b-media>
                           <template v-slot:aside>
                              <img src="@/assets/images/users/avatar-3.jpg" alt class="avatar-md rounded-circle"/>
                              <br>
                           </template>
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">Nazrudhin Shah</h5>
                              <p>
                                 +91 3434343434<br>
                                 naz@test.com
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>

                     <div class="col-md-4">
                        <h5>05 Jun 2022</h5>
                        <p class="mb-0">Mobile Payment: <strong>$150</strong></p>
                        <p class="mb-0">Cash Payment: <strong>$700</strong></p>
                     </div>

                     <div class="col-md-4 d-flex align-items-center">
                        <h2 class="text-right">$850</h2>
                     </div>
                  </div> 
               </b-card>
                  

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Order ID</th>   
                              <th>Customer</th>
                              <th>Fuel</th>
                              <th>Quantity <br>(in litres)</th>
                              <th>Amount</th>
                              <th>Payment Type</th>
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>12345</td>
                              <td>
                                 Zulfi Ali<br>
                                 +91 1234567890<br>
                                 zulfi@gmail.com
                              </td>                 
                              <td>Gasoline</td>
                              <td>10</td>
                              <td>$ 100</td>
                              <td>Mobile</td>
                              
                              <td>05 Mar 2022, 09:30 am</td>
                             
                              <td>
                                 <router-link :to="{ name: 'orders.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>
                           </tr>

                           <tr>
                              <td>12346</td>
                              <td>
                                 Askar Ali<br>
                                 +91 1234567890<br>
                                 askar@gmail.com
                              </td>                 
                              <td>Diesel</td>
                              <td>12</td>
                              <td>$ 200</td>
                              <td>Cash</td>
                              
                              <td>05 Mar 2022, 09:30 am</td>
                             
                              <td>
                                 <router-link :to="{ name: 'orders.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
